import React from 'react';
import logo from '../../Images/DRH-logo.png';
import { useLocation } from 'react-router-dom';
import { handleSignIn, handleSignOut } from '../../Scripts/SignIn';

export default function AppHeader({ appName, onHamburgerClick, showAuthentication, loggedInUser }) {
    const location = useLocation();

    var locationPath = location.pathname;
    var topRightComponent = (<img className="drhorton-logo" alt="DR Horton logo" src={logo} />);
    if (showAuthentication) {
        topRightComponent = loggedInUser?.isAuthenticated ?
            (<div className="app-header-button" onClick={() => handleSignOut(locationPath)}>
                <span className="action">Sign Out</span>
                <span className="userName">{loggedInUser.displayName}</span>
                <i className="dhicon-logout" />
            </div>) :
            (<div className="app-header-button" onClick={() => handleSignIn(locationPath)}>
                <span>Sign In</span>
                <i className="dhicon-user-circle-o" />
            </div>);
    }

    var hamburgerButton = onHamburgerClick && (<div className="hamburgerContainer"><i className="dhicon-menu-hamburger" onClick={onHamburgerClick} /></div>);

    return (<header className="app-header flexbox-flex justify-between">
        <div className="appNameContainer flexbox-flex align-center">
            {hamburgerButton}
            <span className="appName">
                <span className="font-bold">DHI</span>
                {appName}
            </span>
        </div>
        {topRightComponent}
    </header>);
}